<form [signalForm]="configForm" class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-4 py-4">
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Configuration
    </h3>
    <div class="flex flex-col gap-4">
      <lib-signal-text-field
        label="Label"
        [formField]="configForm.label" />
      <lib-signal-text-field
        label="Help text"
        [formField]="configForm.helpText" />
      <lib-signal-number-field
        label="Minimum value"
        [formField]="configForm.min"
        [numberStep]="model().step" />
      <lib-signal-number-field
        label="Maximum value"
        [formField]="configForm.max"
        [numberStep]="model().step" />
      <lib-signal-number-field
        label="Step"
        [formField]="configForm.step"
        [numberMin]="0.01"
        [numberStep]="0.01" />
      <lib-signal-number-field
        label="Default value"
        hint="Automatically filled when the form opens. Respondents can change it."
        [formField]="configForm.defaultValue"
        [numberMin]="model().min"
        [numberMax]="model().max"
        [numberStep]="model().step" />
      <lib-signal-checkbox
        label="Required"
        hint="Respondent must fill this field"
        [formField]="configForm.required" />
    </div>
  </section>
</form>
